export const COUNTRY_CODE_ENUM = {
  FR: 'FR',
  BE: 'BE',
  NL: 'NL',
  DE: 'DE',
  UK: 'UK',
  AU: 'AU',
  NZ: 'NZ',
  US: 'US',
  CA: 'CA',
  MX: 'MX',
}

export const getDefaultSpySettingByCountry = countryCode => {
  const defaultSettings = {
    hourlyRate: 5,
    maxBudgetPerWeek: 0,
    travelAllowancePerMission: 0,
    travelAllowanceCap: 20,
    durationHandToHandMission: 15,
    durationLetterboxMission: 15,
    durationShift: 3,
    missionsPerShift: 3,
  }

  switch (countryCode) {
    case COUNTRY_CODE_ENUM.FR:
      defaultSettings.hourlyRate = 11
      break
    case COUNTRY_CODE_ENUM.BE:
      defaultSettings.hourlyRate = 11
      break
    case COUNTRY_CODE_ENUM.NL:
      defaultSettings.hourlyRate = 11
      break
    case COUNTRY_CODE_ENUM.DE:
      defaultSettings.hourlyRate = 11
      break
    case COUNTRY_CODE_ENUM.UK:
      defaultSettings.hourlyRate = 10
      break
    case COUNTRY_CODE_ENUM.AU:
      defaultSettings.hourlyRate = 20
      break
    case COUNTRY_CODE_ENUM.NZ:
      defaultSettings.hourlyRate = 20
      break
    case COUNTRY_CODE_ENUM.US:
      defaultSettings.hourlyRate = 20
      break
    case COUNTRY_CODE_ENUM.CA:
      defaultSettings.hourlyRate = 20
      break
    case COUNTRY_CODE_ENUM.MX:
      defaultSettings.hourlyRate = 67
      break
  }

  return defaultSettings
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityAddEdit/util/constants.js